var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BoxWrap",
    { attrs: { title: _vm.$t("storeComponents.title.saleDisplay") } },
    [
      _c(
        "el-row",
        { attrs: { gutter: 40 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("HeaderFilter", {
                attrs: { labels: _vm.headerLabers },
                model: {
                  value: _vm.salesForm,
                  callback: function ($$v) {
                    _vm.salesForm = $$v
                  },
                  expression: "salesForm",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 40 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("div", { staticClass: "desc" }, [
                _c("span", { staticClass: "desc" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("storeComponents.common.desc" + _vm.salesForm.type)
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("i", { staticClass: "el-icon-warning-outline" }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tab flex" },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "radioGroup",
                      model: {
                        value: _vm.isSales,
                        callback: function ($$v) {
                          _vm.isSales = $$v
                        },
                        expression: "isSales",
                      },
                    },
                    [
                      _c(
                        "el-radio-button",
                        { attrs: { label: "sales", name: "type" } },
                        [_vm._v(_vm._s(_vm.$t("storeComponents.tab.sales")))]
                      ),
                      _vm._v(" "),
                      _vm.showMoneyTab || _vm.isSalesLeaderHome
                        ? _c(
                            "el-radio-button",
                            { attrs: { label: "money", name: "type" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("storeComponents.tab.money"))
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showIntegralTab
                        ? _c(
                            "el-radio-button",
                            { attrs: { label: "integral", name: "type" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("storeComponents.tab.score"))
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isSales === "money" && _vm.isSalesLeaderHome
                    ? _c(
                        "el-radio-group",
                        {
                          staticClass: "currentType",
                          model: {
                            value: _vm.currentType,
                            callback: function ($$v) {
                              _vm.currentType = $$v
                            },
                            expression: "currentType",
                          },
                        },
                        [
                          _c(
                            "el-radio-button",
                            { attrs: { label: "USD", name: "USD" } },
                            [_vm._v("$USD")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "CNY", name: "CNY" } },
                            [_vm._v("¥RMB")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showIntegralTab
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            icon: "el-icon-set-up",
                            type: "primary",
                          },
                          on: { click: _vm.clickShowSalary },
                        },
                        [_vm._v(_vm._s(_vm.$t("dashboard.bonus.title")))]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("HeaderMore", {
                staticClass: "mt_20",
                attrs: {
                  title: _vm.$t("storeComponents.title.saleDisplay"),
                  "no-title": "",
                  "no-more": _vm.isSales === "money",
                },
                on: {
                  more: function ($event) {
                    return _vm.toMorePage("all")
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tppChartBox" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isSales === "store",
                        expression: "isSales === 'store'",
                      },
                    ],
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "storeStatusItem" },
                      [
                        _c("div", { staticClass: "storeStatusItemTitle" }, [
                          _vm._v(_vm._s(_vm.$t("dashboard.activeStoreTarget"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "storeStatusItemContent" }, [
                          _c(
                            "div",
                            { staticClass: "storeStatusItemContentNum" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.storeASMData.activeCount || "-")
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  " /" +
                                    _vm._s(
                                      _vm.storeASMData.activeTargetCount || "-"
                                    )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "storeStatusItemContentRate" },
                            [
                              _vm.storeASMData.activeRateNum >= 100
                                ? _c("img", {
                                    attrs: {
                                      src: require("@/assets/sfe/sfe-icon.png"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  class:
                                    "" +
                                    (_vm.storeASMData.activeRateNum >= 100
                                      ? "overNum"
                                      : ""),
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.storeASMData.activeRate) + "%"
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-progress", {
                          attrs: {
                            percentage: _vm.standardPercent(
                              _vm.storeASMData.activeRateNum
                            ),
                            "show-text": false,
                            "stroke-width": 20,
                            "define-back-color": "#FEDB00",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "storeStatusItem" },
                      [
                        _c("div", { staticClass: "storeStatusItemTitle" }, [
                          _vm._v(_vm._s(_vm.$t("dashboard.signStoreTarget"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "storeStatusItemContent" }, [
                          _c(
                            "div",
                            { staticClass: "storeStatusItemContentNum" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.storeASMData.signingCount || "-")
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  " /" +
                                    _vm._s(
                                      _vm.storeASMData.signingTargetCount || "-"
                                    )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "storeStatusItemContentRate" },
                            [
                              _vm.storeASMData.signRateNum >= 100
                                ? _c("img", {
                                    attrs: {
                                      src: require("@/assets/sfe/sfe-icon.png"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  class:
                                    "" +
                                    (_vm.storeASMData.signRateNum >= 100
                                      ? "overNum"
                                      : ""),
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.storeASMData.signRate) + "%"
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-progress", {
                          attrs: {
                            percentage: _vm.standardPercent(
                              _vm.storeASMData.signRateNum
                            ),
                            "show-text": false,
                            "stroke-width": 20,
                            "define-back-color": "#FEDB00",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "tip" }, [
                      _c("i", { staticClass: "el-icon-warning-outline" }),
                      _vm._v(_vm._s(_vm.$t("dashboard.storeTip"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isSales !== "store",
                      expression: "isSales !== 'store'",
                    },
                  ],
                  staticClass: "echarts300 echarts300Scale mt_revers20",
                  attrs: { id: "id_asmCompRate" },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { style: _vm.isSales !== "store" ? "margin-top:-20px" : "" },
                [
                  _vm.isSales === "integral"
                    ? _c("IntegralTextBoard", {
                        attrs: {
                          "source-data": _vm.saleIntegralData,
                          type: _vm.isSales,
                        },
                      })
                    : _vm.isSales === "money"
                    ? _c("MoneyTextBoard", {
                        attrs: {
                          "source-data": _vm.saleMoneyData,
                          type: _vm.currentType,
                        },
                      })
                    : _vm.isSales !== "store"
                    ? _c("SaleTextBoard", {
                        attrs: {
                          "source-data": _vm.saleDisplayData,
                          type: _vm.isSales,
                        },
                        on: { actualCountDetail: _vm.actualCountDetail },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isSalesLeaderHome
                ? _c("HeaderMore", {
                    staticClass: "mt_20",
                    attrs: { title: _vm.$t("dashboard.order"), "no-more": "" },
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isSalesLeaderHome
                ? _c("TargetByOrder", {
                    attrs: {
                      "source-data": _vm.orderStatus,
                      form: _vm.orderForm,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("HeaderMore", {
                staticClass: "mt_20",
                attrs: { title: _vm.$t("dashboard.target"), "no-more": "" },
              }),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _vm.isSalesLeaderHome
                        ? _c("TargetBoard", {
                            attrs: {
                              theme: "blue",
                              title: "LUX",
                              "item-data": _vm.target_LUX,
                            },
                          })
                        : _c("TargetValue", {
                            attrs: {
                              theme: "LUX",
                              "item-data": _vm.target_LUX,
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _vm.isSalesLeaderHome
                        ? _c("TargetBoard", {
                            attrs: {
                              theme: "orange",
                              title: "SUV",
                              "item-data": _vm.target_SUV,
                            },
                          })
                        : _c("TargetValue", {
                            attrs: {
                              theme: "SUV",
                              "item-data": _vm.target_SUV,
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _vm.isSalesLeaderHome
                        ? _c("TargetBoard", {
                            attrs: {
                              theme: "yellow",
                              title: "EV",
                              "item-data": _vm.target_EV,
                            },
                          })
                        : _c("TargetValue", {
                            attrs: { theme: "EV", "item-data": _vm.target_EV },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("HeaderMore", {
                staticClass: "mt_20",
                attrs: { title: _vm.$t("dashboard.mix") },
                on: {
                  more: function ($event) {
                    return _vm.toMorePage("prodSize")
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("MixBoard", {
                        attrs: {
                          title: "18+",
                          theme: "blue",
                          "item-data": _vm.mixData_18,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("MixBoard", {
                        attrs: {
                          title: "19+",
                          theme: "blue",
                          "is-show-aop": _vm.isSalesLeaderHome,
                          "item-data": _vm.mixData_19,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("MixBoard", {
                        attrs: {
                          title: "20+",
                          theme: "blue",
                          "is-show-aop": _vm.isSalesLeaderHome,
                          "item-data": _vm.mixData_20,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("HeaderMore", {
                staticClass: "mt_20",
                attrs: { title: _vm.$t("dashboard.newProduct") },
                on: {
                  more: function ($event) {
                    return _vm.toMorePage("newProdcut")
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "new-products" },
                [
                  _vm._l(_vm.newProductsData, function (product, pIndex) {
                    return _c(
                      "div",
                      { key: pIndex, staticClass: "new-product-item" },
                      [
                        _c(
                          "div",
                          { staticClass: "light-blue-board" },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(_vm._s(product.title)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "values" }, [
                              _c("div", { staticClass: "nums" }, [
                                _c("span", { staticClass: "num1 blue" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.paddingNum(product.actualCount) == 0
                                        ? "-"
                                        : _vm.paddingNum(product.actualCount)
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "space" }, [
                                  _vm._v("/"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "num2" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.paddingNum(product.aopCount) == 0
                                        ? "-"
                                        : _vm.paddingNum(product.aopCount)
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.paddingNum(product.aopCount) == 0
                                        ? "-"
                                        : _vm.paddingNum(product.finishRate)
                                    ) +
                                    "%\n                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-progress", {
                              attrs: {
                                percentage:
                                  product.finishRate > 100
                                    ? 100
                                    : product.finishRate,
                                color: "#004EA8",
                                "show-text": false,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.newProductsData.length % 3 === 2
                    ? _c("div", { staticClass: "new-product-item" })
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("HeaderMore", {
                staticClass: "mt_30",
                attrs: {
                  title: _vm.$t("storeComponents.title.shop"),
                  "no-more": "",
                },
              }),
              _vm._v(" "),
              _c("Shop", {
                staticClass: "mt_10",
                attrs: { "source-data": _vm.storeData, form: _vm.storeForm },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            "is-show": _vm.isShowModel,
            width: "700px",
            "destroy-on-close": "",
            "is-only-confirm": "",
            "custom-title": _vm.$t("dashboard.salesReport"),
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowModel = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowModel = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.reportList,
                    stripe: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "spName",
                      label: _vm.$t("sfe.reportModule.salesReport.spName"),
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rsmEmpNo",
                      label: _vm.$t("sfe.reportModule.salesReport.rsmEmpNo"),
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rsmName",
                      label: _vm.$t("sfe.reportModule.salesReport.rsmName"),
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderQty",
                      label: _vm.$t("sfe.reportModule.salesReport.orderQty"),
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(_vm._s(_vm.paddingNum(scope.row.orderQty))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "deliverQty",
                      label: _vm.$t("sfe.reportModule.salesReport.deliverQty"),
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.paddingNum(scope.row.deliverQty))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "receiptQty",
                      label: _vm.$t("sfe.reportModule.salesReport.receiptQty"),
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.paddingNum(scope.row.receiptQty))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.total > 0,
                    expression: "total > 0",
                  },
                ],
                attrs: {
                  total: _vm.total,
                  page: _vm.currPage,
                  limit: _vm.limit,
                },
                on: {
                  "update:page": function ($event) {
                    _vm.currPage = $event
                  },
                  "update:limit": function ($event) {
                    _vm.limit = $event
                  },
                  pagination: _vm.fetchList,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            "is-show": _vm.showSalary,
            width: "400px",
            "destroy-on-close": "",
            "is-only-confirm": "",
            "custom-title": _vm.$t("dashboard.bonus.title"),
          },
          on: {
            "update:isShow": function ($event) {
              _vm.showSalary = $event
            },
            "update:is-show": function ($event) {
              _vm.showSalary = $event
            },
          },
        },
        [
          _c("div", [
            _c("div", [_vm._v(_vm._s(_vm.$t("dashboard.bonus.bonusMonth")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "salaryContent" },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    model: {
                      value: _vm.bonusMonth,
                      callback: function ($$v) {
                        _vm.bonusMonth = $$v
                      },
                      expression: "bonusMonth",
                    },
                  },
                  _vm._l(
                    _vm.lookupList["BONUS_CALCULATION_MONTH"],
                    function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.code },
                      })
                    }
                  ),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("dashboard.bonus.salary")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "salaryContent" },
              [
                _c("el-input", {
                  attrs: { type: "number" },
                  model: {
                    value: _vm.salary,
                    callback: function ($$v) {
                      _vm.salary = $$v
                    },
                    expression: "salary",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "small",
                      plain: "",
                      type: _vm.salary && _vm.bonusMonth ? "primary" : "",
                    },
                    on: { click: _vm.onBonusCalculation },
                  },
                  [_vm._v(_vm._s(_vm.$t("dashboard.bonus.button")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("dashboard.bonus.bonus")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "salaryContent" },
              [
                _c("el-input", {
                  attrs: { value: _vm.salaryRes, disabled: "" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tip" }, [
              _c("i", { staticClass: "el-icon-warning-outline" }),
              _vm._v(_vm._s(_vm.$t("dashboard.bonus.tip"))),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }